import { createFleetUseCase } from '@src/main/modules/parameters/application/create/create-fleet.usecase';
import { CreateUpdateFleetRequest } from '@src/main/modules/parameters/infrastructure/dto/createUpdateFleetRequest';
import { createFleetHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/FleetHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useCreateFleet = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createFleetHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (data: CreateUpdateFleetRequest) => {
      if (!repository) throw new Error('Repository not initialized');
      return await createFleetUseCase(data, tokenProvider);
    },
  });
};
